import React, { useEffect, useState } from "react";
import "./Branding_Benifits.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useParams } from "react-router-dom";
import Benifits_Component from "../../../Common_Component/Benifits_Component/Benifits_Component";

const Branding_Benifits = () => {
  const [brandingBenefitsData, setBrandingBenefitsData] = useState([]);
  const { id } = useParams();

  const data = [
    {
      id: 1,
      benefits: [
        { title: "Unique Identity", descn: "Stand out from competitors with a custom-designed logo tailored to your brand." },
        { title: "Professional Appeal", descn: "A polished logo builds trust and credibility with your audience." },
        { title: "Versatility", descn: "Designed to look great across all platforms—social media, websites, packaging, and more." },
        { title: "Timeless Design", descn: "Create a logo that remains relevant as your business grows." },
        { title: "Memorability", descn: "Make a strong first impression with a logo that sticks in customer’s minds." },
      ],
    },
    {
      id: 2,
      benefits: [
        { title: "Enhanced Visual Appeal", descn: "Professional designs that grab attention and resonate with your audience." },
        { title: "Brand Consistency", descn: "Cohesive graphics across all platforms to strengthen brand identity." },
        { title: "Effective Communication", descn: "Convey your message clearly and creatively through visuals." },
        { title: "Increased Engagement", descn: "Drive likes, shares, and interactions with compelling designs." },
        { title: "Competitive Edge", descn: "Stand out in your industry with unique, high-quality graphics." },
      ],
    },
    {
      id: 3,
      benefits: [
        { title: "Professional Identity", descn: "Establish a polished, credible presence that builds trust." },
        { title: "Consistent Branding", descn: "Strengthen recognition with a unified visual language." },
        { title: "Emotional Connection", descn: "Design that resonates with your audience and creates loyalty." },
        { title: "Competitive Edge", descn: "Distinguish yourself from competitors with a unique identity." },
        { title: "Scalability", descn: "A brand design that grows and adapts as your business evolves." },
      ],
    } 
  ];

  useEffect(() => {
    const filteredArray = data.filter((item) => item.id === Number(id));
    setBrandingBenefitsData(filteredArray);
  }, [id]);

  return (
    <div className="Benifits">
      <div className="container">
        <div className="title_div">
          <p className="title">Benefits</p>
        </div>
        <div className="card_holder_main_div">
          <Swiper
            className="mySwiper"
            spaceBetween={10}
            slidesPerView={6}
            modules={[Pagination]}
            pagination={{ dynamicBullets: true, clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10 },
              425: { slidesPerView: 1.3, spaceBetween: 15 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1200: { slidesPerView: 3, spaceBetween: 25 },
            }}
          >
            {brandingBenefitsData?.[0]?.benefits?.map((item, index) => (
              <SwiperSlide key={index}>
                <Benifits_Component
                  className={index === 0 ? "first-component" : ""}
                  title={item.title}
                  description={item.descn}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Branding_Benifits;
